import { RequestDocument } from "./DocumentList";
import { RequestStatus } from "./RequestsStatusEnum";
import BigNumber from "bignumber.js";
import { RequestHistory } from "./RequestHistory";

export class Requests {
    public id: string;
    public userId: string;
    public currentStatus: RequestStatus;
    public documentList?: Array<RequestDocument> = [];
    public history?: Array<RequestHistory> = [];
    public createdAt: Date;
    public analist?: string;
    public approvedBy?: string;
    public valueRequested: BigNumber;
    public valueOffered?: BigNumber;
    public tokenQuotation: BigNumber;
    public userAccepted?: boolean;
    public analistInfo?: any;
    public user?: any;
    public comment?: string;
}

export class RequestsSearch {
    public status: RequestStatus;
    public from: Date;
    public to: Date;
    public minValue: number;
    public maxValue: number;
    public orderForMax: boolean;
    public orderForMin: boolean;
}